export const baseUrl = "https://www.backend.carrygo.org";
